import { createFileRoute, redirect } from '@tanstack/react-router'

import { getAuthState } from '@/lib/auth'

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    const { isAuthenticated } = await getAuthState()
    throw redirect({
      to: isAuthenticated ? '/trials' : '/login',
    })
  },
})
